export default "__VITE_ASSET__DXecWkgA__"